import { CreditCard } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatCurrency } from '@/lib/utils'

interface FinancePreviewCardProps {
  valor: string
}

export function FinancePreviewCard({ valor }: FinancePreviewCardProps) {
  const valorNumerico = valor.trim() === '' ? 0 : Number(valor)
  const display = Number.isNaN(valorNumerico) ? 0 : valorNumerico

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="h-5 w-5 text-primary" />
          Resumo financeiro
        </CardTitle>
        <CardDescription>Informe o valor esperado para este participante</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 text-sm">
        <div className="rounded-lg border border-primary/20 bg-primary/5 p-3">
          <p className="text-xs uppercase text-muted-foreground">Valor informado</p>
          <p className="text-lg font-semibold">{formatCurrency(display)}</p>
        </div>
        <p className="text-xs text-muted-foreground">
          O valor e método registrados aqui serão utilizados como referência durante o recebimento
          presencial. Você poderá ajustar o pagamento diretamente na tela do evento.
        </p>
      </CardContent>
    </Card>
  )
}
